import React from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Checkbox, Image, ListItemWithImage, StatusBadge, Text } from '@campaignhub/suit-theme'

import Icons from '@components/Icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faFile, faLink } from '@fortawesome/pro-light-svg-icons'
import useClientResource from '@hooks/useClientResource'

import decodeBase64Url from '@functions/decodeBase64Url'

const ListView = (props) => {
  const { editable, file, selected, selectContent } = props

  const { callbacks: { launchClientResourceModal } } = useClientResource()

  const isLink = file?.metadata?.type === 'link'
  const decodedLinkUrl = isLink ? decodeBase64Url(file?.metadata?.link) : null

  const thumbnailUrl = file?.content_type?.startsWith('image/') ? file?.download_uri : file?.metadata?.thumbnail
  const imageUrl = thumbnailUrl || ''

  return (
    <ListItemWithImage imageComponent={(
      <Box
        alignItems="center"
        as="a"
        borderRight={['none', '1px solid']}
        borderBottom={['1px solid', 'none']}
        borderColor={['lineColor', 'lineColor']}
        href={isLink ? decodedLinkUrl : file?.download_uri}
        justifyContent="center"
        padding="medium"
        style={{ textDecoration: 'none' }}
        width={['100%', 'fit-content']}
        target="_blank"
      >
        {isLink ? (
          <Box
            alignItems="center"
            backgroundColor="hoverLightGrey"
            borderRadius={5}
            color="bodyFontColor"
            display="grid"
            height={[180, '100%']}
            justifyContent="center"
            width={['100%', 200]}
          >
            <FontAwesomeIcon icon={faLink} size="3x" />
          </Box>
        ) : (
          <Image
            backgroundPosition="center center"
            boxProps={{
              backgroundColor: 'hoverLightGrey',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain',
            }}
            borderRadius={5}
            height={[180, '100%']}
            url={imageUrl}
            width={['100%', 200]}
          >
            {!imageUrl && (
              <Box
                alignItems="center"
                color="bodyFontColor"
                display="grid"
                justifyContent="center"
                width="100%"
              >
                {(file?.content_type === 'application/pdf' || file?.content_type?.startsWith('video/')) ? (
                  <Icons
                    name={file?.content_type === 'application/pdf' ? 'Floorplan' : 'Video'}
                    size={40}
                    width="100%"
                  />
                ) : (
                  <FontAwesomeIcon icon={faFile} size="3x" />
                )}
              </Box>
            )}
          </Image>
        )}
      </Box>
    )}
    >
      <ListItemWithImage.Header>
        <ListItemWithImage.HeaderLeft boxProps={{ maxWidth: '75%!important' }}>
          <ListItemWithImage.HeaderText>
            <Text variant="ellipsis" width="100%">
              {file?.metadata?.name || file.name}
            </Text>
          </ListItemWithImage.HeaderText>
        </ListItemWithImage.HeaderLeft>
        {editable && (
          <ListItemWithImage.HeaderRight>
            <Checkbox checked={selected} marginRight={0} onClick={() => selectContent(file)} />
          </ListItemWithImage.HeaderRight>
        )}
      </ListItemWithImage.Header>
      <ListItemWithImage.Footer>
        <ListItemWithImage.FooterLeft boxProps={{ maxWidth: '75%!important' }}>
          <Box fontSize="small" marginBottom="medium" alignItems="center">
            <StatusBadge
              color="mysteryGrey"
              text={file?.content_type}
            />
          </Box>
          <Text color="bodyFontLightColor" fontSize="xsmall" variant="ellipsis" width="100%">
            {file?.metadata?.notes?.replace(/\\n/g, '\n') || ''}
          </Text>
        </ListItemWithImage.FooterLeft>
        {file?.metadata?.notes && (
          <ListItemWithImage.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faEye} />}
              onClick={() => launchClientResourceModal(file)}
              size="medium"
              height={37}
            >
              View
            </Button>
          </ListItemWithImage.FooterRight>
        )}
      </ListItemWithImage.Footer>
    </ListItemWithImage>
  )
}

ListView.propTypes = {
  editable: PropTypes.bool,
  file: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  selectContent: PropTypes.func,
}

export default ListView
